<template>
    <div style="text-align: center;">
        <div class="text-center mt-0 mb-3">
            <i class="pi pi-user-plus text-7xl text-blue-500"></i>
        </div>
        
    <div class="flex flex-column justify-content-center user_register_box" style="direction: rtl;">
        <div class="flex justify-content-center gap-2 sm-gap">
            <div class="input-container">
                <IconField iconPosition="right">
                <InputIcon class="pi pi-user-plus mx-2"> </InputIcon>
                <InputText type="text" v-model="firstName" :placeholder="$t('FIRST_NAME')" style="text-align: center; width: 100%;" />
            </IconField> 
            </div>
            

            <div class="input-container">
                <IconField iconPosition="right">
                <InputIcon class="pi pi-user-plus mx-2"> </InputIcon>
                <InputText type="text" v-model="lastName" :placeholder="$t('LAST_NAME')" style="text-align: center; width: 100%;" />
            </IconField>
            </div>
            
        </div>

        <div class="input-container">
            <IconField iconPosition="right">
                <InputIcon class="pi pi-envelope mx-2"> </InputIcon>
                <InputText type="email" v-model="email" :placeholder="$t('EMAIL')" style="text-align: center; width: 100%;" />
            </IconField>
        </div>

        <div class="flex justify-content-center gap-2 sm-gap">
            <div class="input-container">
                <div class="p-inputgroup" style="width: 100%;">
                    <Password class="password-field" v-model="password" toggleMask :feedback="false"
                        :placeholder="$t('PASSWORD_FIELD')" style="text-align: center; width: 100%;" />
                </div>
            </div>
            <div class="input-container">
                <div class="p-inputgroup" style="width: 100%;">
                    <Password class="password-field" v-model="passwordConfirmation" toggleMask :feedback="false"
                        :placeholder="$t('PASSWORD_FIELD_CONFIRMATION')" style="text-align: center; width: 100%;" />
                </div>
            </div>
        </div>

        <Button icon="pi pi-send mx-1" :label="$t('SEND_REQUEST')" style="margin-top: 0.5em;" :disabled="!canSendRequest" @click="sendRequest" />
    </div>
</div>




</template>

<script setup>
import { computed, inject, ref } from 'vue'
import userService from '@/service/UserService'
import { useI18n } from 'vue-i18n'

import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';

import Password from 'primevue/password';

const emit = defineEmits(['error', 'requestSent', 'validationError'])

const dialogRef = inject('dialogRef')
const i18n = useI18n()

const firstName = ref()
const lastName = ref()
const email = ref()
const password = ref()
const passwordConfirmation = ref()

const canSendRequest = computed(() => {
    return firstName.value !== null && firstName.value !== undefined && firstName.value !== "" &&
        lastName.value !== null && lastName.value !== undefined && lastName.value !== "" &&
        email.value !== null && email.value !== undefined && email.value !== "" &&
        password.value !== null && password.value !== undefined && password.value !== "" &&
        passwordConfirmation.value !== null && passwordConfirmation.value !== undefined && passwordConfirmation.value !== ""
})

const sendRequest = async () => {
    try {
        if (password.value !== passwordConfirmation.value) {
            emit('validationError', i18n.t('PASSWORD_NOT_MATCHING'))
        } else if (!emailIsValid(email)) {
            emit('validationError', i18n.t('INVALID_EMAIL'))
        } else {
            const response = await userService.createJoinRequest(firstName.value, lastName.value, email.value, password.value)
            emit('requestSent', response.message)
            dialogRef.value.close()
        }
    } catch (e) {
        emit('error', e)
    }
}

const emailIsValid = (input) => {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return input.value.match(validRegex)
}

</script>

<style scoped>

 .input-container {
        width: 100%;
        margin: 0.5em 0;
    }

    @media (max-width: 768px) {
        .flex {
            flex-direction: column;
        }

        .input-container {
            width: 100%;
        }

        .sm-gap {
            gap: 0 !important;
        }
    }

</style>